import { useFormContext, useFormState } from "react-hook-form";
import FormCheckbox from "../../shared/FormCheckbox";
import FormInputText from "../../shared/FormInputText";
import FormSelect from "../../shared/FormSelect";
import { USA_STATES } from "../../../utils/constants";

const step = 2;
const TopAccountStepTwo = ({ activeStep }) => {
    const { control, register } = useFormContext();
    const { errors } = useFormState({ control });

    if (activeStep !== step) return null;

    return (
        <div style={{ width: "50%" }}>
            <FormCheckbox
                label={'Ignore Address Check'}
                name={'ignorePrimaryAddressCheck'}
                control={control}
            />
            <br />
            <FormInputText label={'Primary Correspondence - Address Line 1'} register={register} name={'primaryAddress1'} errors={errors} placeholder="Address" />
            <FormInputText label={'Primary Correspondence - Address Line 2'} register={register} name={'primaryAddress2'} errors={errors} placeholder="Address (optional)" />
            <FormInputText label={'Primary Correspondence - Address Line 3'} register={register} name={'primaryAddress3'} errors={errors} placeholder="Address (optional)" />
            <FormInputText label={'Primary Correspondence - Address City'} register={register} name={'primaryAddressCity'} errors={errors} placeholder="City" />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '2rem' }}>
                <FormSelect
                    label={'Primary Correspondence - Address State'}
                    name={'primaryAddressState'}
                    control={control}
                    options={USA_STATES}
                    errors={errors}
                    placeholder="Select a state"
                />
                <FormInputText label={'Primary Correspondence - Address Zip'} register={register} name={'primaryAddressZip'} errors={errors} placeholder="Zip code" />
            </div>
        </div>
    );
};

export default TopAccountStepTwo;
